module.exports = __webpack_public_path__ + "img/Montgomery-House-interior-2013-230_CC_SN.f2eb18e0.webp";